// Понятные сообщения по кодам ошибок сервера. Сообщение говорит, что произошло
// и что сделать дальше; сервер может прислать своё пояснение (message/detail).
const messages: Record<string, string> = {
  slot_taken: 'Это время только что заняли. Выберите другое.',
  too_soon: 'Это время уже недоступно. Выберите время позже.',
  too_far: 'На эту дату запись пока не открыта.',
  not_reception_time: 'В это время студия не принимает машины.',
  rate_limited: 'Слишком много попыток. Подождите минуту и повторите.',
  invalid_phone: 'Проверьте номер телефона.',
  invalid_token: 'Ссылка на запись недействительна. Проверьте адрес или позвоните в студию.',
  too_late_to_change: 'Запись уже нельзя изменить онлайн. Позвоните в студию.',
  tenant_not_found: 'Студия не найдена. Проверьте адрес ссылки.',
  idempotency_conflict: 'Запрос уже отправлялся с другими данными. Обновите страницу.',
  forbidden: 'Нет доступа к этой студии.',
  not_authenticated: 'Войдите в кабинет.',
  network: 'Нет соединения с сервером. Проверьте интернет и повторите.',
};

export class ApiError extends Error {
  constructor(
    public code: string,
    message?: string,
  ) {
    super(message && message !== code ? message : (messages[code] ?? 'Не получилось выполнить действие. Повторите.'));
    this.name = 'ApiError';
  }
}

export function toApiError(e: unknown): ApiError {
  if (e instanceof ApiError) return e;
  if (e && typeof e === 'object' && 'message' in e) {
    const m = String((e as { message: unknown }).message);
    const detail = 'details' in e ? String((e as { details: unknown }).details ?? '') : '';
    if (/fetch|network/i.test(m)) return new ApiError('network');
    if (messages[m]) return new ApiError(m, detail || undefined);
    return new ApiError('unknown', detail || undefined);
  }
  return new ApiError('unknown');
}

export function errorText(e: unknown): string {
  return toApiError(e).message;
}
